/**
 * Fonte única das cores de status e do acento de IA — paleta "Miguel Comprador".
 *
 * Antes, cada tela definia seu próprio mapa de cores (≈11 cópias de STATUS_BADGE)
 * com cores genéricas do Tailwind (red-600/orange-500/yellow-400). Isso quebrava a
 * coerência de marca. Aqui centralizamos só o PAR DE COR (bg+text) por status — cada
 * call site compõe com o próprio shape (h-8 badge, pill px-2, filtro h-11, etc.).
 *
 * Tokens vêm de tailwind.config.js / src/index.css:
 *   danger #9C3A3C · warn #F09656 · monitor #C9A24B · accent (lima) #C7CD23 · brand (verde floresta)
 *
 * NÃO inclui o semáforo da matriz de Ressuprimento (status.* no tailwind:
 * ruptura/em-producao/minimo/medio/cheio) — esse é um sistema de cores intencional
 * e bem compreendido; recolorir quebraria a leitura.
 */
import type { CommercialStatus, OrderStatus, SeparationStatus } from '../types'

// ── Status comercial (Motor de Sugestão de Compras) ───────────────────────────
export const commercialStatusColor: Record<CommercialStatus, string> = {
  'Compra urgente': 'bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-300',
  'Comprar':        'bg-orange-100 text-orange-700 dark:bg-orange-500/15 dark:text-orange-300',
  'Monitorar':      'bg-amber-100 text-amber-800 dark:bg-amber-500/15 dark:text-amber-300',
  'Não comprar':    'bg-sunken text-ink-muted',
}

// ── Status de pedido de compra ────────────────────────────────────────────────
// "Enviado" mantém o azul (estado de trânsito convencional, sem token de marca
// equivalente). "Recebido" passa a usar o verde da marca.
export const orderStatusColor: Record<OrderStatus, string> = {
  Pendente:  'bg-amber-100 text-amber-800 dark:bg-amber-500/15 dark:text-amber-300',
  Enviado:   'bg-sky-100 text-sky-700 dark:bg-sky-500/15 dark:text-sky-300',
  Recebido:  'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300',
  Cancelado: 'bg-sunken text-ink-muted',
}

// ── Status de lista de separação (matriz → filial) ────────────────────────────
export const separationStatusColor: Record<SeparationStatus, string> = {
  criada:   'bg-sky-100 text-sky-700 dark:bg-sky-500/15 dark:text-sky-300',
  separada: 'bg-amber-100 text-amber-800 dark:bg-amber-500/15 dark:text-amber-300',
  recebida: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300',
}

// ── Acento de IA (✨) — lima da marca, substitui o violeta legado ──────────────
/** Botão sólido de IA (Analisar / Explicar). Lima sobre verde escuro. */
export const AI_BTN = 'bg-accent text-brand-900 font-bold hover:brightness-95 active:brightness-95 disabled:opacity-50'
/** Caixa/painel de resultado da IA — tint verde + borda lima. */
export const AI_PANEL = 'bg-brand-700/30 border border-accent/30'
/** Rótulo/eyebrow "✨ IA". */
export const AI_LABEL = 'text-accent'
